<script>
import { WithBreakpointComponent } from './breakpoints';
export default {
    mixin: [WithBreakpointComponent],
    props: {
        fade: {type: Boolean, default: true}
    },
    data: () => ({
        elem: undefined,
        opacity: 0,
        rgb: [9, 42, 73],
        isScrolling: false
    }),
    computed: {
        range() {
            let range = 126;
            if (this.currentBreakpoint === 'phone') {
                range = 80;
            } else if (this.currentBreakpoint === 'tablet') {
                range = 100;
            }
            return range;
        }
    },
    mounted() {
        if (this.fade) {
            this.elem = $(this.$refs.header);
            console.log(this.$refs.header);
            window.addEventListener('scroll', this.handleScroll, false);
        }
    },
    beforeDestroy() {
        if (this.fade) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        animateNav() {
            const scrollTop = $(window).scrollTop();
            const height = this.elem.height();
            const calc = (1 + (scrollTop - this.range) / this.range).toFixed(2);
            if (calc > 1) {
                this.elem.css({
                    backgroundColor: `rgba(${this.rgb[0]}, ${this.rgb[1]}, ${this.rgb[2]}, 1)`
                });
            } else if (calc < 0) {
                this.elem.css({
                    backgroundColor: `rgba(${this.rgb[0]}, ${this.rgb[1]}, ${this.rgb[2]}, 0)`
                });
            } else {
                this.elem.css({
                    backgroundColor: `rgba(${this.rgb[0]}, ${this.rgb[1]}, ${this.rgb[2]}, ${calc})`
                });
            }
            this.isScrolling = false;
        },
        handleScroll(e) {
            if (!this.isScrolling) {
                window.requestAnimationFrame(this.animateNav);
            }
            this.isScrolling = true;
        }
    }
}
</script>
